// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-question-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 400px;
    max-height: 500px;
    overflow-y: auto;
    border-radius: 30px;
}

.edit-question-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #42cf1f;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 400px;
    max-height: 500px;
    overflow-y: auto;
    border-radius: 30px;
    z-index: 1001; /* Ensure the modal is above other elements */
  }



.maintain-overflow-question{
    overflow-y: auto;
}

.add-question-dialog::-webkit-scrollbar {
    width: 12px;
}

.add-question-dialog::-webkit-scrollbar-thumb {
    background-color: skyblue;
    border-radius: 30px;
}

.add-question-dialog::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}

.form-field {
    margin-bottom: 20px;
}

.label {
    margin-bottom: 8px;
}

.input-question {
    padding: 8px;
    margin-bottom: 16px;
}

.button-group {
    display: flex;
    justify-content: space-between;
}

.cancel-button {
    padding: 10px;
    cursor: pointer;
    background-color: #ccc;
    border: none;
    border-radius: 4px;
}

.inz-dropdown{
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.inz-title{
    text-align: center;
    background-color: rgb(102, 247, 247);
    color: black;
    border-radius: 30px;
    padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/ManageContent/managecontentforms/managecontentstyle/AddActivityQuestion.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa,EAAE,6CAA6C;EAC9D;;;;AAIF;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".add-question-dialog {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #ffffff;\n    padding: 20px;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    width: 400px;\n    max-height: 500px;\n    overflow-y: auto;\n    border-radius: 30px;\n}\n\n.edit-question-dialog {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #42cf1f;\n    padding: 20px;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    width: 400px;\n    max-height: 500px;\n    overflow-y: auto;\n    border-radius: 30px;\n    z-index: 1001; /* Ensure the modal is above other elements */\n  }\n\n\n\n.maintain-overflow-question{\n    overflow-y: auto;\n}\n\n.add-question-dialog::-webkit-scrollbar {\n    width: 12px;\n}\n\n.add-question-dialog::-webkit-scrollbar-thumb {\n    background-color: skyblue;\n    border-radius: 30px;\n}\n\n.add-question-dialog::-webkit-scrollbar-track {\n    background-color: #f5f5f5;\n}\n\n.form-field {\n    margin-bottom: 20px;\n}\n\n.label {\n    margin-bottom: 8px;\n}\n\n.input-question {\n    padding: 8px;\n    margin-bottom: 16px;\n}\n\n.button-group {\n    display: flex;\n    justify-content: space-between;\n}\n\n.cancel-button {\n    padding: 10px;\n    cursor: pointer;\n    background-color: #ccc;\n    border: none;\n    border-radius: 4px;\n}\n\n.inz-dropdown{\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.inz-title{\n    text-align: center;\n    background-color: rgb(102, 247, 247);\n    color: black;\n    border-radius: 30px;\n    padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
